//連携サービス登録 /topUser4
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import users from './store/user';
import {browserHistory} from 'react-router';
import firebase from "firebase";
import {getUserId} from './firebase'
import {onLogin} from './firebase'
import define from './define';
import request from 'request-promise';

import JSEncrypt from 'node-jsencrypt';

import './css/topUser4.css';


export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      me:{},
      uid:'',
      id: '',
      pass: '',
      domain: decodeURIComponent(window.location.search).replace("?domain=",""),
      domain_name: "",
      icon: "/img/icons/icon_" + decodeURIComponent(window.location.search).replace("?domain=","") + ".png",
      getRecord:'',
      photoURL: "",
      submitStart:false
    };
    // uidの取得
    getUserId((uid)=>{
      this.setState({uid:uid})
    })  
  }
  
  handleSubmit(e){
    this.setState({submitStart: true});

    // DBに保存開始
    var db = firebase.database();

    // 日時データ準備
    var cd = new Date(); 
    var datetime = cd.getFullYear() + "-" + (cd.getMonth()+1)  + "-" + cd.getDate() + " " + cd.getHours() + ":" + cd.getMinutes() + ":" + cd.getSeconds();

    // アクセスURLによってDBとScorerの接続先を変える
    var userRef = {};
    var domainUrl = "";
    if ("yahoo_auction" === this.state.domain) {
      userRef = db.ref("users/" + this.state.me.uid + "/ids/yahoo_auction/");           // DB接続先
      domainUrl = "/crawlers/newly/yahoo_auction.rb?userid=" + users.getMyUser().uid    // Scorer接続先
    } else if ("coconala" === this.state.domain) {
      userRef = db.ref("users/" + this.state.me.uid + "/ids/coconala/");
      domainUrl = "/crawlers/newly/coconala.rb?userid=" + users.getMyUser().uid
    } else if ("anyca" === this.state.domain) {
      userRef = db.ref("users/" + this.state.me.uid + "/ids/anyca/");
      domainUrl = "/crawlers/newly/anyca.rb?userid=" + users.getMyUser().uid
    } else if ("notteco" === this.state.domain) {
      userRef = db.ref("users/" + this.state.me.uid + "/ids/notteco/");
      domainUrl = "/crawlers/newly/notteco.rb?userid=" + users.getMyUser().uid
    } else if ("spacemarket" === this.state.domain) {
      userRef = db.ref("users/" + this.state.me.uid + "/ids/spacemarket/");
      domainUrl = "/crawlers/newly/space_market.rb?userid=" + users.getMyUser().uid
    // } else if ("rakuma" === this.state.domain) {
    //   //20180425 rakuma
    //   userRef = db.ref("users/" + this.state.me.uid + "/ids/rakuma/");
    //   domainUrl = "/crawlers/newly/rakuma.rb?userid=" + users.getMyUser().uid
    } else if ("minne" === this.state.domain) {
      //20180514 minne
      userRef = db.ref("users/" + this.state.me.uid + "/ids/minne/");
      domainUrl = "/crawlers/newly/minne.rb?userid=" + users.getMyUser().uid
    }

    // IDを「A*B*C****」形式に
    let id_tmp = this.state.id;
    var id_mask = id_tmp.slice(0, 1) + "*" + id_tmp.slice(2, 3) + "*" + id_tmp.slice(4, 5);
    if (0 < (id_tmp.length - 5)) {
      id_mask = id_mask + "*".repeat(id_tmp.length - 5);
    }

    // データ暗号化準備
    var encrypt = new JSEncrypt();
    encrypt.setPublicKey(define.SCORER_SERVER.pem);
    
    // ID, Passともに暗号化
    var data = {
      id: encrypt.encrypt(this.state.id),
      id_mask: id_mask,
      password: encrypt.encrypt(this.state.pass),
      created_at: datetime
    }

    // DBにset
    userRef.set(data);


    // Scorerをキック
    var options = {
      url: define.SCORER_SERVER.url + domainUrl,
      method: 'GET'
    }
    request(options, function (err, res, body) {
      // 完了後もとのマイページへ
      //browserHistory.push("/user");
    });

    // キック投げっぱなしのままマイページへ
    browserHistory.push("/user/" + this.state.uid);
  }

  handleChangeId(value){
    this.setState({ id: value });
  }

  handleChangePass(value){
    this.setState({ pass: value });
  }

  componentWillUnmount = () => {
    const {
      uid
    } = this.state
    firebase.database().ref('users/' + uid).off('value')
  }
  // onload
  componentDidMount() {
    //var scope = this
    // ログインチェック
    onLogin(() => {
      this.setState({ me: users.getMyUser(), photoURL: users.getMyUser().photoURL });
    })


    switch(this.state.domain){
      case "yahoo_auction": this.setState({domain_name: "ヤフオク!"});break;
      case "coconala": this.setState({domain_name: "ココナラ"});break;
      case "anyca": this.setState({domain_name: "Anyca"});break;
      case "notteco": this.setState({domain_name: "notteco"});break;
      case "spacemarket": this.setState({domain_name: "スペースマーケット"});break;
      //20180425 rakuma
      // case "rakuma": this.setState({domain_name: "ラクマ"});break;
      //20180514 minne
      case "minne": this.setState({domain_name: "minne"});break;
      default:
    }
   this.setDefValue()
  }


  clearService = (e) => {
    
    const {
      domain_name
    } = this.state
    e.preventDefault()
    if(!window.confirm(domain_name + 'の連携を解除しますか？')) return
    let clearDomain = e.currentTarget.dataset.service
    //console.log(clearDomain)
    firebase.database().ref('users/' + users.getMyUser().uid + '/ids/' + clearDomain).set(null);
    firebase.database().ref('scores').orderByChild('userid').equalTo(users.getMyUser().uid).once('value').then((snapshot) => {
      //console.log(snapshot.val())
      let data = snapshot.val() || {}
      Object.keys(data).forEach((key) => {
        if(data[key].domain === clearDomain) {
          let update = data[key]
          update.disabled = true
          firebase.database().ref('scores/' + key).set(update)
        }
      })
      this.setDefValue()    
    });
  }

  setDefValue = () => {
    const {
      domain,
    } = this.state
    
    let ids = users.getMyUser().ids
    if(ids && ids[domain]) {
      this.setState({ id: '**********' });
      this.setState({ pass: '**********' });
    } else {
      this.setState({ id: '' });
      this.setState({ pass: '' });      
    }
  }

  showSubmitBtn = () => {
    const {
      domain,
      domain_name
    } = this.state
        
    let ids = users.getMyUser().ids
    //console.log(ids)

    if(ids && ids[domain]) {
        return (
          <button type="button" onClick={this.clearService} className="submit clear" data-service={domain}>{domain_name}を解除する</button>
        )
    } else {
      return (
          <button type="button" onClick={(e) =>this.handleSubmit(e)} className="submit">送信</button>
      )
    }
  }

render(){
  return(
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-topUser4 wrapper-accountSetting">
        <Header/>
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top content-topUser4">
                <div className="block-topUser4">
                  <h2 className="title">Add Record</h2>
                  <img className="title_icon" src={this.state.icon} alt="" />
                  <p className="subtitle">{this.state.domain_name}から取得する情報</p>
                  <ul>
                  {(() => {
                    switch(this.state.domain){
                      case "yahoo_auction": return <ul><li>・あなたの総合評価</li><li>・あなたの評価の割合</li><li>・あなたの出品時の評価</li><li>・あなたの良い評価の割合</li><li>・あなたの落札時の評価</li><li>・あなたの落札時の良い評価の割合</li></ul>
                      case "coconala": return <ul><li>・あなたの販売実績数</li><li>・あなたの出品者ランク</li><li>・あなたの購入者情報の最大評価数</li></ul>
                      case "anyca": return <ul><li>・あなたの星の数</li><li>・あなたが受けたレビュー件数</li></ul>
                      case "notteco": return <ul><li>・あなたの星の数</li><li>・あなたのrating件数</li><li>・あなたのドライブ回数</li><li>・あなたの運転技術評価</li></ul>
                      case "spacemarket": return <ul><li>・あなたの星の数</li><li>・あなたが受けたレビュー件数</li><li>・あなたがトップホストかどうか</li></ul>
                      //20180425 rakuma
                      // case "rakuma": return (
                      //   <ul>
                      //     <li>・あなたの評価</li>
                      //     <li>・あなたの出品での評価</li>
                      //     <li>・あなたの出品での良い評価の割合</li>
                      //     <li>・あなたの購入での評価</li>
                      //     <li>・あなたの購入での良い評価の割合</li>
                      //   </ul>
                      // )
                      //20180514 minne
                      case "minne": return (
                        <ul>
                          <li>・あなたの星の数</li>
                          <li>・あなたが受けたレビュー件数</li>
                        </ul>
                      )     
                    
                      default:
                    }
                  })()}
                  </ul>
                </div>
                <div className="line-dashed" />
                <div className="block-basicInfo clearfix">
                  <form className="">
                    <div className="form-group">
                      <label>{this.state.domain_name}のログインID</label>
                      <input type="text" className="form-control" name="" value={this.state.id} onChange={(e) =>this.handleChangeId(e.target.value)}/>
                    </div>
                    <div className="form-group">
                      <label>{this.state.domain_name}のパスワード</label>
                      <input type="password" className="form-control" name="" value={this.state.pass} onChange={(e) =>this.handleChangePass(e.target.value)}/>
                    </div>

                    { this.state.submitStart ? <div className="load"><img src="img/icons/load.gif" alt=""/></div> : null }
                    {this.showSubmitBtn()}
                  </form>
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/topUser4.js